var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("11、交完房租不吃土，在沪一月一千五。（猜一个税专项附加扣除项目）")])])
}]

export { render, staticRenderFns }